
import axios from 'axios';
import { getAuthHeader } from '../../utils';
import { prepareFormDataForImageUpload } from '../../imageUploadQuality';

export const v1_update_globalSetting = async (model) => {
    const url = `${process.env.REACT_APP_BASE_URL}/v1/globalSettings`;
    const payload = await prepareFormDataForImageUpload(model);
    return axios.post(url, payload, getAuthHeader()).then((res) => {
        return res.data;
    })
}


export const v1_fetch_globalSetting = async () => {
    const url = `${process.env.REACT_APP_BASE_URL}/v1/globalSettings`;
    return axios.get(url).then((res) => {
        return res.data;
    })
}
